import { useTranslation } from 'react-i18next';
import { QuestionTypeEnum } from '@/models/Question';
import { DragDropAnswer } from '@/components/question/view/primitives/shared/dnd';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import {
  SEQUENCE_SLOT_ID,
  useOrderingAnswerView,
} from '@/components/question/view/typologies/ordering/useOrderingAnswerView';
import isEmpty from 'lodash/isEmpty';

const surface = 'rounded-2xl border border-base-300 bg-base-200 px-4 py-6';

export function OrderingAnswerView(
  props: QuestionViewPropsFor<QuestionTypeEnum.DND_ORDENATION>,
) {
  const { tokens, slots, flow, placement, handlePlacementChange, disabled } =
    useOrderingAnswerView(props);
  const { t } = useTranslation('translation', { keyPrefix: 'questionView' });

  if (isEmpty(tokens)) return null;

  return (
    <DragDropAnswer
      tokens={tokens}
      slots={slots}
      placement={placement}
      onPlacementChange={handlePlacementChange}
      flow={flow}
      disabled={disabled}
      className={surface}
    >
      <DragDropAnswer.Slot
        id={SEQUENCE_SLOT_ID}
        ariaLabel={t('ordering.sequenceLabel')}
        className="min-h-24 w-full flex-wrap content-start items-start justify-start rounded-sm border border-dashed border-secondary p-4"
      />
      <DragDropAnswer.Bank />
    </DragDropAnswer>
  );
}
